<template>
  <div class="detail-article-wrapper" :class="{ internal: isInternal }">
    <h1 class="title">{{ article.title }}</h1>
    <div class="meta-info">
      <div v-if="!isInternal" class="author">
        作者：<b class="author-name">{{ article.author }}</b>
      </div>
      <div class="publishing" :class="{ 'font-color-notice': isInternal }">
        <span class="pub-date">
          {{ article.release_time | relativeTimeFormat('M月D日') }}
          <template v-if="!isInternal">
            发布在
            <router-link
              :to="{
                path: '/article/list',
                query: {
                  type: article.type.id
                }
              }"
              class="font-color-body"
            >
              {{ article.type.name }}
            </router-link>
          </template>
        </span>
      </div>
      <div
        v-if="article.keyword"
        class="keywords"
        :class="{ 'font-color-notice': isInternal }"
      >
        {{ article.keyword.replace(/,/g, '、') }}
      </div>
    </div>
    <ul v-if="article.tag && article.tag.length > 0" class="tag-list">
      <li v-for="tag in article.tag" :key="tag.id">
        <a
          :href="`https://hd.weibo.com/search/list?type=article&keyword=${tag.name}`"
          target="_blank"
          class="tag-item font-color-body"
        >
          {{ tag.name }}
        </a>
      </li>
    </ul>
    <div class="description" :class="{ hidden: !article.description }">
      {{ article.description }}
    </div>
    <div class="body">
      <DetailWidgets :content-info="article" :pkg="pkg"></DetailWidgets>
    </div>
    <div class="footer">
      <ul v-if="article.tag && article.tag.length > 0" class="tag-list">
        <li v-for="tag in article.tag" :key="tag.id">
          <a
            :href="`https://hd.weibo.com/search/list?type=article&keyword=${tag.name}`"
            target="_blank"
            class="tag-item font-color-body"
          >
            {{ tag.name }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import DetailWidgets from '@/components/widget/DetailWidgets'

export default {
  components: {
    DetailWidgets
  },
  props: {
    article: {
      type: Object,
      required: true
    },
    pkg: {
      type: Object,
      default: () => ({})
    },
    isInternal: Boolean
  },
  data() {
    return {
      favoriteDisabled: false,
      praiseDisabled: false
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin: 0 0 32px;
  font-size: 36px;
  font-weight: bold;
  line-height: normal;
}
.meta-info {
  font-size: 14px;
  width: 100%;
  overflow: hidden;
  margin-bottom: 16px;
  b,
  a {
    font-size: 14px;
    font-weight: bold;
  }
  .author {
    float: left;
    margin-right: 40px;
  }
  .publishing {
    float: left;
  }
  .keywords {
    float: left;
    margin-left: 40px;
  }
  .actions {
    float: right;
    button {
      background-color: transparent;
      border: none;
      outline: none;
      cursor: pointer;
      margin-right: 24px;
      font-size: 14px;
      vertical-align: middle;
      i {
        font-size: 22px;
        vertical-align: middle;
        margin-right: 3px;
      }
      span {
        vertical-align: middle;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.tag-list {
  overflow: hidden;
  margin-bottom: 48px;
  li {
    float: left;
    margin: 0 12px 12px 0;
  }
  .tag-item {
    display: block;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    font-size: 12px;
    background-color: #f4f5f7;
    border-radius: 3px;
    &:hover {
      background-color: #3352fe;
      color: #ffffff;
    }
  }
}
.description {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 64px;
  background-color: #fcfafb;
  border-left: 4px solid #3352fe;
  padding: 18px 32px 18px 24px;
  &.hidden {
    visibility: hidden;
    margin-bottom: 0;
  }
}
.internal {
  .description {
    font-size: 18px;
    padding: 18px 24px;
    background-color: #fafafb;
    border-left: 4px solid #3352fe;
  }
}
.body {
  margin-bottom: 32px;
}
</style>
